import { updateModel } from 'vuex-bound';
import { injectLanguage } from '@/core/i18n.js';
import countdownMutations from './countdown.js';
import emailVerificationMutations from './emailVerification.js';
import mfaMutations from './mfa.js';
import otpMutations from './otp.js';

export default {
  ...updateModel(),
  injectLanguage,
  ...countdownMutations,
  ...emailVerificationMutations,
  ...mfaMutations,
  ...otpMutations,
  setRecaptcha(state, recaptcha) {
    state.recaptcha = recaptcha;
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setAllowAction(state, allowAction) {
    state.allowAction = allowAction;
  },
  setSignUpFormColumn(state, signUpFormColumn) {
    state.signUpFormColumn = signUpFormColumn;
  },
  setShowAccountLinkingNotice(state, showAccountLinkingNotice) {
    state.showAccountLinkingNotice = showAccountLinkingNotice;
  },
  setIsAccountDuplicated(state, isAccountDuplicated) {
    state.isAccountDuplicated = isAccountDuplicated;
  },
  setIsAccountInputFixed(state, isAccountInputFixed) {
    state.isAccountInputFixed = isAccountInputFixed;
  },
  setIsPasswordSet(state, isPasswordSet) {
    state.isPasswordSet = isPasswordSet;
  },
  setPrefilledEmailAccount(state, data) {
    state.isAccountPrefilled = true;
    state.prefilledAccount = data.email;
    state.emailAddr = data.email;
  },
  setPrefilledSocialInfo(state, data) {
    state.googleEmail = data.social_google_email;
    state.appleEmail = data.social_apple_email;
    state.lineEmail = data.social_line_email;
    state.username = data.username;
  },
  setPrefilledSmsAccount(state, data) {
    state.isAccountPrefilled = true;
    state.prefilledAccount = data.sms_phone_number;
    state.phoneCode = data.sms_country_code;
    state.phoneNumber = data.sms_phone_number;
    state.nationalNumber = data.sms_phone_number;
  },
  setSupportAuthMethod(state, supportAuthMethod) {
    state.supportAuthMethod = supportAuthMethod;
  },
  setHasCheckSession(state, hasCheckSession) {
    state.hasCheckSession = hasCheckSession;
  },
  setIsoCountryCode(state, code) {
    state.isoCountryCode = code;
  },
  setEmailAccount(state, account) {
    state.emailAddr = account;
  },
  setPhoneNumberAccount(state, account) {
    state.phoneNumber = account;
  },
  setNationalNumber(state, phone) {
    state.nationalNumber = phone;
  },
  setPhoneCode(state, code) {
    state.phoneCode = code;
  },
  setSignInStep(state, step) {
    state.signInStep = step;
  },
  setSignUpStep(state, step) {
    state.signUpStep = step;
  },
  ableToSignIn(state, isAbleToSignIn) {
    state.isAbleToSignIn = isAbleToSignIn;
  },
  setSignInErrMsg(state, signInErrMsg) {
    state.signInErrMsg = signInErrMsg;
  },
  setSignUpErrMsg(state, signUpErrMsg) {
    state.signUpErrMsg = signUpErrMsg;
  },
  setEmailError(state, emailError) {
    state.emailError = emailError;
  },
  setPhoneError(state, phoneError) {
    state.phoneError = phoneError;
  },
  setPhoneOtpCode(state, phoneOtpCode) {
    state.phoneOtpCode = phoneOtpCode;
  },
  setSignInType(state, type) {
    state.signInType = type;
  },
  setIsVerifying(state, isVerifying) {
    state.isVerifying = isVerifying;
  },
  setIsCodeSentFail(state, isCodeSentFail) {
    state.isCodeSentFail = isCodeSentFail;
  },
  resetPrefilledAccount(state) {
    state.isAccountPrefilled = false;
    state.prefilledAccount = '';
    state.emailAddr = '';
    state.isPasswordSet = false;
    state.supportAuthMethod = [];
    state.isFromEmailConflict = false;
  },
  setIsFromEmailConflict(state, isFromEmailConflict) {
    state.isFromEmailConflict = isFromEmailConflict;
  },
  setShowOldSsoUi(state, showOldSsoUi) {
    state.showOldSsoUi = showOldSsoUi;
  },
  setUiMode(state, uiMode) {
    state.uiMode = uiMode;
  },
  setSupportLineOauth(state, supportLineOauth) {
    state.supportLineOauth = supportLineOauth;
  },
  setSupportInappPolling(state, supportInappPolling) {
    state.supportInappPolling = supportInappPolling;
  },
  setCheckAccountEmail(state, email) {
    state.checkAccountEmail = email;
  },
  setCheckAccountPhone(state, phone) {
    state.checkAccountPhone = phone;
  },
  setCheckAccountExists(state, exists) {
    state.checkAccountExists = exists;
  },
  setCheckAccountSupportAuthMethod(state, supportAuthMethod) {
    state.checkAccountSupportAuthMethod = supportAuthMethod;
  },
};
